var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#17a2b8",
    height: "200px",
    width: "200px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297 297",
    xmlSpace: "preserve",
    transform: "rotate(0)matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M191.512,89.598c-10.64-3.549-31.168-11.596-40.456-17.883L92.797,32.268c-9.288-6.289-20.673-3.863-25.301,5.393 c-4.625,9.254-2.222,23.601,5.344,31.883l27.803,30.18H20.396C9.178,99.664,0,108.543,0,119.76v0.969 c0,11.217,9.178,20.395,20.396,20.395C9.178,141.123,0,150.301,0,161.518v1.58c0,11.217,9.178,20.395,20.396,20.395h14.732 c-11.217,0-20.392,9.178-20.392,20.395v1.58c0,11.217,9.176,20.395,20.392,20.395h16.825c-11.215,0-20.393,9.178-20.393,20.395 v1.58c0,11.217,9.179,20.395,20.393,20.395h78.771c11.218,0,28.602-4.105,38.637-9.121l22.15-11.076V89.598z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M270.427,71.871h-36.71c-13.758,0-25.082,10.518-26.417,23.93v144.336l0.14-0.068 c1.919,12.779,12.971,22.611,26.277,22.611h36.71c14.652,0,26.573-11.92,26.573-26.572V98.445 C297,83.793,285.079,71.871,270.427,71.871z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.5204bdf48b12dc28213fd3ba5177b311.svg";
export { ForwardRef as ReactComponent };